/**
 * 180 Marketing light theme for AI-Vis.
 * Values match 180marketing_system_design.json. Do not import styles/colors.js.
 */

export const tokens = {
  green50: '#f5fbe9',
  green100: '#e8f5cf',
  green200: '#d2eaa2',
  green300: '#bbdf74',
  green500: '#9ccb3b',
  green600: '#84b02c',
  green700: '#688a23',
  green800: '#4b641b',
  green900: '#2f3f11',

  graphite25: '#fbfbfc',
  graphite50: '#f6f7f8',
  graphite100: '#eeeff1',
  graphite200: '#e2e4e6',
  graphite300: '#c9cccf',
  graphite400: '#a2a6aa',
  graphite500: '#7c8084',
  graphite600: '#545557',
  graphite700: '#414244',
  graphite800: '#2e2f31',
  graphite900: '#1d1e1f',

  white: '#ffffff',

  positive500: '#2e9e5b',
  positive100: '#dff3e7',
  positiveInk: '#1f7a45',

  caution500: '#e0a02f',
  caution100: '#fbf0d9',
  cautionInk: '#8a5a10',

  critical500: '#d4483f',
  critical100: '#fae3e1',
  criticalInk: '#a33a33',

  info500: '#3b7fc4',
  info100: '#e0ecf8',
  infoInk: '#2a5f96',
};

/** Chart series. First five are the design cycle; the rest keep longer charts distinct. */
export const chartSeries = [
  tokens.green600,
  tokens.info500,
  tokens.green800,
  tokens.caution500,
  tokens.graphite600,
  tokens.green900,
  tokens.critical500,
];

export const fitColors = {
  'Good Fit': { bg: tokens.positive100, color: tokens.positiveInk },
  'Moderate Fit': { bg: tokens.caution100, color: tokens.cautionInk },
  'Poor Fit': { bg: tokens.critical100, color: tokens.criticalInk },
};

/** Categorical source types, drawn from the 180 green scale and status hues. */
export const sourceTypeColors = {
  reddit: tokens.info500,
  product_roundup: tokens.green700,
  review: tokens.caution500,
  ecommerce: tokens.green800,
  review_site: tokens.graphite600,
  client: tokens.positive500,
  homepage: tokens.green600,
  video: tokens.critical500,
  other: tokens.graphite400,
};

export const radius = {
  xs: '4px',
  sm: '8px',
  md: '12px',
  lg: '16px',
  xl: '24px',
  pill: '999px',
};

export const shadow = {
  xs: '0 1px 2px rgba(29,30,31,.05)',
  sm: '0 1px 3px rgba(29,30,31,.06), 0 1px 2px rgba(29,30,31,.04)',
  md: '0 4px 12px rgba(29,30,31,.07), 0 1px 3px rgba(29,30,31,.04)',
  lg: '0 12px 28px rgba(29,30,31,.09), 0 2px 6px rgba(29,30,31,.04)',
  xl: '0 24px 56px rgba(29,30,31,.12), 0 4px 10px rgba(29,30,31,.05)',
  brand: '0 8px 20px rgba(132,176,44,.28)',
};

export const font = {
  sans: '"Inter", -apple-system, "Segoe UI", sans-serif',
  display: '"Outfit", "Inter", -apple-system, "Segoe UI", sans-serif',
};
